import './DownloadLEIL.css';
import DownloadImg1 from './images/download-img1.jpg';
import DownloadImg2 from './images/download-img2.jpg';
import DownloadImg3 from './images/download-img3.jpg';
import DownloadImg4 from './images/download-img4.jpg';

function DownloadLEIL(){
    return(
        <div className="home-download" id='download'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-3">
                        <h2 className="heading2">Downloads<span>Legal Entity Identifier India Limited</span></h2>
                    </div>
                    <div className="col-md-9">
                        <ul>
                            <li>
                                <img src={DownloadImg1} />
                                <div className="whitebox">
                                    <p><strong>Legal Doc Download</strong>Auditor’s Certificate Format Download Certificate Format</p>
                                    <a href="#">Read More <i class="fas fa-chevron-right"></i></a>
                                </div>
                            </li>
                            <li>
                                <img src={DownloadImg2} />
                                <div className="whitebox">
                                    <p><strong>File Download</strong>User Legal Doc Download Download File Anonymous</p>
                                    <a href="#">Read More <i class="fas fa-chevron-right"></i></a>
                                </div>
                            </li>
                            <li>
                                <img src={DownloadImg3} />
                                <div className="whitebox">
                                    <p><strong>LEI Certificate</strong>Auditor’s Certificate Format Download Certificate Format</p>
                                    <a href="#">Read More <i class="fas fa-chevron-right"></i></a>
                                </div>
                            </li>
                            <li>
                                <img src={DownloadImg4} />
                                <div className="whitebox">
                                    <p><strong>Download Invoice</strong>Auditor’s Certificate Format Download Certificate Format</p>
                                    <a href="#">Read More <i class="fas fa-chevron-right"></i></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}export default DownloadLEIL;